import React, { FunctionComponent } from 'react'
import { ReactComponent as LoadNotFoundIllustration } from '../illustrations/LoadNotFoundIllustration.svg'

export const LoadNotFound: FunctionComponent = () => (
  <section className='container tc'>
    <LoadNotFoundIllustration />
    <h2>Load not found!</h2>
    <p>We couldn’t find the load you’re looking for.</p>
  </section>
)

export default LoadNotFound
